/**
 * talkrouteCrashReporter.js
 * Talkroute
 *
 * Created by Vel Genov on 12/12/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import * as Sentry from "@sentry/browser";

/**
 * Start the crashReporter service
 */
const startCrashReporter = (isProduction: boolean, sentryDSN?: string) => {
  // Initialize Sentry for crash reporting
  const defaultDSN =
    "https://774d9091c26f48f49853d06cb65b5c17@o216462.ingest.sentry.io/6386568";
  let dsn = defaultDSN;
  if (sentryDSN) {
    dsn = sentryDSN;
  }  

  Sentry.init({
    dsn,
    release: process.env.RELEASE,
    environment: isProduction ? "production" : "develop",
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: ["webapp-api.talkroute.com/api/", "testing-webapp-api.talkroute.com/api/"],
      })
    ],
    tracesSampleRate: 0.05,
  });
};

const startTalkrouteCrashReporter = (isProduction: boolean, sentryDSN?: string) => {
  startCrashReporter(isProduction, sentryDSN);
};

export default startTalkrouteCrashReporter;
